'use strict';

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

exports.stringToBytes = function (string) {
  return _toConsumableArray(string).map(function (character) {
    return character.charCodeAt(0);
  });
};

var uint8ArrayUtf8ByteString = function uint8ArrayUtf8ByteString(array, start, end) {
  return String.fromCharCode.apply(String, _toConsumableArray(array.slice(start, end)));
};

exports.tarHeaderChecksumMatches = function (buffer) {
  // Does not check if checksum field characters are valid
  if (buffer.length < 512) {
    // `tar` header size, cannot compute checksum without it
    return false;
  }

  var MASK_8TH_BIT = 0x80;
  var sum = 256; // Intitalize sum, with 256 as sum of 8 spaces in checksum field

  var signedBitSum = 0; // Initialize signed bit sum

  for (var i = 0; i < 148; i++) {
    var byte = buffer[i];
    sum += byte;
    signedBitSum += byte & MASK_8TH_BIT; // Add signed bit to signed bit sum
  } // Skip checksum field


  for (var _i = 156; _i < 512; _i++) {
    var _byte = buffer[_i];
    sum += _byte;
    signedBitSum += _byte & MASK_8TH_BIT; // Add signed bit to signed bit sum
  }

  var readSum = parseInt(uint8ArrayUtf8ByteString(buffer, 148, 154), 8); // Read sum in header
  // Some implementations compute checksum incorrectly using signed bytes

  return (// Checksum in header equals the sum we calculated
    readSum === sum || // Checksum in header equals sum we calculated plus signed-to-unsigned delta
    readSum === sum - (signedBitSum << 1)
  );
};

exports.uint8ArrayUtf8ByteString = uint8ArrayUtf8ByteString;
/**
ID3 UINT32 sync-safe tokenizer token.
28 bits (representing up to 256MB) integer, the msb is 0 to avoid "false syncsignals".
*/

exports.uint32SyncSafeToken = {
  get: function get(buffer, offset) {
    return buffer[offset + 3] & 0x7F | buffer[offset + 2] << 7 | buffer[offset + 1] << 14 | buffer[offset] << 21;
  },
  len: 4
};